<div class="bdo-table">
  <table class="table--desktop">
    <thead>
      <tr>
        <th>{{ 'meterreadings.info.meterreadingDate' | translate }}</th>
        @if (ablesungen) {
          <th class="data--long  bdo-text--right">{{ 'meterreadings.meterreadingIn' | translate }} {{ablesungen[0]?.einheitStand | unitPretty}} </th>
        }
        @if (ablesungen) {
          <th class="data--long  bdo-text--right">{{ 'meterreadings.history.consumptionIn' | translate }} {{ablesungen[0]?.einheitVerbrauch | unitPretty}}  <span aria-describedby="verbrauch_info">*</span></th>
        }
        <th colspan="2" class="table-head--limited---delete">{{ 'meterreadings.history.meterreadingReason' | translate }}, {{ 'meterreadings.history.meterreadingType' | translate }}</th>
      </tr>
    </thead>
    @if (ablesungen?.length > 0) {
      <tbody>
        @for (ablesung of ablesungen | slice: 0:totalRecords; track ablesung) {
          <tr>
            <td class="bdo-font--monospace">{{ablesung.ablesedatum | date}}</td>
            <td class="bdo-text--right bdo-font--monospace">
              @for (stand of ablesung?.staende; track stand) {
                <span>
                  {{stand.stand | dotToComma}}
                  @if (ablesung?.staende?.length>1) {
                    <span>
                      {{ stand.typ }} <br>
                    </span>
                  }
                </span>
              }
            </td>
            <td class="bdo-text--right bdo-font--monospace">
              @for (stand of ablesung?.staende; track stand) {
                <span>
                  {{stand.verbrauch | dotToComma }}
                  @if (ablesung?.staende?.length>1) {
                    <span>
                      {{ stand.typ }} <br>
                    </span>
                  }
                </span>
              }
            </td>
            <td> {{ablesung.ablesegrund | mapAblesegrund}}, {{ablesung.ableseart | mapAbleseart}}</td>
            <td>
              @if (zaehlerNummer && ablesung.canBeEdited && !editDisabled) {
                <button class="re-w-20 re-block icon"
                  (click)="onEdit(ablesung.ablesedatum)"
                  title="{{ 'general.imgText.edit' | translate }}">
                  <svg-icon src="{{ 'general.img.edit' | translate }}"></svg-icon>
                </button>
              }
            </td>
          </tr>
        }
      </tbody>
    }
  </table>
</div>

@for (ablesung of ablesungen | slice: 0:totalRecords; track ablesung) {
  <div class="re-mb-5 table--tablet" >
    <div class="bdo-tile space-line re-mb-2">
      <div class="re-mb-15">
        <div class="bold">{{ 'meterreadings.info.meterreadingDate' | translate }}</div>
        {{ablesung.ablesedatum | date}}
      </div>
      <div class="re-mb-15">
        <div class="bold">{{ 'meterreadings.meterreading' | translate }}</div>
        @for (stand of ablesung.staende; track stand) {
          <span>
            {{stand.stand | dotToComma }} {{ablesung.einheitStand | unitPretty}}
            @if (ablesung.staende?.length>1) {
              <span>
                {{ stand.typ }} <br>
              </span>
            }
          </span>
        }
      </div>
      <div class="re-mb-15">
        <div class="bold">{{ 'meterreadings.history.consumptionWithRemark' | translate }}</div>
        @for (stand of ablesung.staende; track stand) {
          <span>
            {{stand.verbrauch | dotToComma }} {{ablesung.einheitVerbrauch | unitPretty}}
            @if (ablesung.staende?.length>1) {
              <span>
                {{ stand.typ }} <br>
              </span>
            }
          </span>
        }
      </div>
      <div class="re-mb-15">
        <div class="bold">{{ 'meterreadings.history.meterreadingReason' | translate }}</div>
        {{ablesung.ablesegrund | mapAblesegrund}}
      </div>
      <div class="re-mb-15">
        <div class="bold">{{ 'meterreadings.history.meterreadingType' | translate }}</div>
        {{ablesung.ableseart | mapAbleseart}}
      </div>
    </div>
    @if (zaehlerNummer && ablesung.canBeEdited) {
      <div class="bdo-tile">
        <div class="re-flex-row re-flex bold hover-container">
          <button class="icon" (click)="onEdit(ablesung.ablesedatum)">
            {{ 'general.action.edit' | translate }}
            <svg-icon src="{{ 'general.img.edit' | translate }}"
              class="re-w-24 re-ml-10">
            </svg-icon>
          </button>
        </div>
      </div>
    }
  </div>
}

@if (ablesungen?.length > 0) {
  <p id="verbrauch_info" class="re-mt-15 re-mb-30" >{{ 'meterreadings.history.consumptionSinceLastReading' | translate }}</p>
}

@if (ablesungen?.length > totalRecords) {
  <bdo-more-button
    [label]="'general.action.showMore' | translate"
    (moreEvent)="addRecords()"
  ></bdo-more-button>
}

@if (!ablesungen || ablesungen.length < 1) {
  <bdo-no-data
    [text]="'meterreadings.history.noMeterreadingsFound' | translate"
  ></bdo-no-data>
}
